var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    { staticClass: "nti-related-product" },
    [
      _vm.data
        ? _c("h5", { staticClass: "nti-related-product__container-title" }, [
            _vm._v(_vm._s(_vm.labels.relatedCollectionBannerSectionTitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.data, function (card) {
        return [
          _c("a", { key: card.id, attrs: { href: card.link } }, [
            _c(
              "article",
              {
                staticClass: "nti-related-product__card",
                style: {
                  backgroundImage: `linear-gradient(0deg, rgba(38, 48, 56, 0.8), rgba(38, 48, 56, 0.8)), url(${card.imageUrl})`,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "nti-related-product__card__left-container" },
                  [
                    _c(
                      "h3",
                      { staticClass: "nti-related-product__card__title" },
                      [_vm._v(_vm._s(card.title))]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "nti-related-product__card__text" },
                      [_vm._v(_vm._s(card.description))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nti-related-product__card__right-container" },
                  [
                    card.priceText
                      ? _c(
                          "h3",
                          { staticClass: "nti-related-product__card__price" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "nti-related-product__card__small-font",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.verifyLabel("fromPriceLabel")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(card.priceText) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      { staticClass: "nti-button nti-button--related-product" },
                      [_vm._v(_vm._s(card.buttonText))]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }